<template>
	<div>
		<div class="form-group_up">
			<label class="form-label" for="name-f">
                {{__t('SEARCH')}}
            </label>
			<div class="input-group">
				<div class="input-group-prepend">
				<span class="input-group-text  border-right-0">
					<i class="fal fa-democrat"></i>
				</span>
				</div>


				<input type="text" v-model="search_param" id="filter_search" class="form-control" :placeholder="__t('SEARCH')">

				<div class="input-group-append srch">
					<button class="btn btn-primary shadow-0 waves-effect waves-themed" v-on:click="send_search">
						<i class="fal fa-search"></i>
					</button>
					<button
						v-on:click="show_filter"
						type="button" class="btn btn-outline-primary shadow-0 waves-effect waves-themed">
						{{__t('ADVANCED_FILTER')}}
					</button>
					<button type="button" class="btn btn-danger shadow-0  waves-effect waves-themed"
							v-on:click="clear_form">
						<span class="fal fa-times mr-1"></span>
						{{__t("CLEAN_FILTER")}}
					</button>

				</div>
			</div>
			<span class="help-block">
                {{__t('SEARCH_HELPER')}}
            </span>
		</div>

        <!--
        <div class="collapse show">
            <div class="mt-1">
                <div class="small badge border border-info  text-info mr-1">
                Rocket
            </div>
                <div class="small badge border border-warning text-black-50  mr-1">
                FO
                </div>
            </div>
        </div>
        -->

		<div class="collapse show" id="imc_filter" style="" v-if="is_show_filter">
			<div class="form-group js-stools-container-filters">
				<div class="d-flex flex-wrap ">
					<div class="flex-fill mt-2 mb-2">
                        <!--
						<imc_select
							filter_name="org_id"
							hidden_input="org_inp"
							items_url="internal/catalog/organizations"
							active_filed_name="title"
							active_filed_val="id"
							placeholder="Бренд Фільтр"
							:active_id="this.active_org"
						></imc_select>
						-->
					</div>
				</div>
			</div>
		</div>
	</div>


</template>

<script>
import {createHelpers} from 'vuex-map-fields';
import Imc_select from "../../sys/xml_fields/imc_select";

const {mapFields} = createHelpers({
	getterType: 'inbox_state/getInboxStateField',
	mutationType: 'inbox_state/updateInboxStateField',
});

export default {
	name: "filter_catalog",
	components: {Imc_select},
	data() {
		return {
			is_load: false,
			is_active_filter : false,
			search_txt: "",
			rows: [],
		}
	},

	created() {

		this.search_txt = this.search_param;

	},


	methods: {

		show_filter () {
			this.is_active_filter = true;
		},

		clear_form() {
			EventBus.$emit('clean_inbox_filter');
		},

		send_search() {
			EventBus.$emit('search_inbox_called', this.search_txt);
		},

        async load_providers() {

        },

	},

	computed: {

		is_show_filter() {
			if(this.active_org > 0) {
				return true;
			}

			return this.is_active_filter;
		},

		...mapFields([
			'list',
			'pagination',
			'send_list',
			'all_filter',
			'filter'
		]),

		active_org() {
			if (this.all_filter.hasOwnProperty('org_id')) {
				return parseInt(this.all_filter.org_id);
			}
			return 0;
		},

		search_param: {
			get: function () {
				if (this.all_filter.hasOwnProperty('search')) {
					if ( this.all_filter.search == null ) {
						return "";
					}
					return this.all_filter.search;
				}
                return "";
			},
			set: function (newValue) {
				this.search_txt = newValue;
			}
		},

	}
}
</script>

<style scoped>

</style>
